var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122 122"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7664",
    d: "M61 122a61.179 61.179 0 0061-61c0-33.55-27.958-61-61-61S0 27.45 0 61c0 33.042 27.958 61 61 61z",
    fill: "#28cd41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7665",
    d: "M54.392 89.975c-2.542 0-4.067-1.017-6.1-3.558L34.058 68.625a6.762 6.762 0 01-1.525-4.067 5.334 5.334 0 015.592-5.592c2.033 0 3.558.508 5.083 3.05l10.675 14.742 23.891-39.142a5.435 5.435 0 014.575-3.05c3.05 0 5.591 2.033 5.591 5.083 0 1.525-1.016 3.05-1.525 4.575l-26.942 42.7a5.588 5.588 0 01-5.081 3.051z",
    fill: "#fff"
  })));
}
export default SvgSuccessIos;